import { camelCase } from 'lodash'

const requireModule = require.context('.', false, /\.js$/) //extract vue files inside modules folder

const components = {}

const capitalise = s => {
    if (typeof s !== 'string') return ''
    return s.charAt(0).toUpperCase() + s.slice(1)
}

const pascalCase = s => capitalise(camelCase(s))

requireModule.keys().forEach(fileName => {
    const componentName = pascalCase(fileName.replace(/(\.\/|\.js)/g, ''))

    components[componentName] = requireModule(fileName).default
})

export default components

const {
    // technology
    InternalDataAnimation,
    ExternalDataAnimation,
    BusinessIntelligenceAnimation,
    DataScienceAnimation,
    ArtificialIntelligenceAnimation,
    // strategy
    CustomVisualsAnimation,
    AlignStrategyAnimation,
    // culture
    DataEducationAnimation,
    DataEthicsAnimation,
    // proto
    SpeedIterationAnimation,
    CommercialAlignmentAnimation,
    // empowerment
    HandsOnAnimation,
    PerpetuatingInnovationAnimation,
    // policy
    PrivacyPolicyAnimation,
    SecurityPolicyAnimation
} = components

const technologyAnimations = {
    InternalDataAnimation,
    ExternalDataAnimation,
    BusinessIntelligenceAnimation,
    DataScienceAnimation,
    ArtificialIntelligenceAnimation
}

const strategyAnimations = {
    CustomVisualsAnimation,
    AlignStrategyAnimation
}

const cultureAnimations = {
    DataEducationAnimation,
    DataEthicsAnimation
}

const prototypeAnimations = {
    SpeedIterationAnimation,
    CommercialAlignmentAnimation
}

const empowermentAnimations = {
    HandsOnAnimation,
    PerpetuatingInnovationAnimation
}

const policyAnimations = {
    PrivacyPolicyAnimation,
    SecurityPolicyAnimation
}

export {
    technologyAnimations,
    strategyAnimations,
    cultureAnimations,
    prototypeAnimations,
    empowermentAnimations,
    policyAnimations
}
